import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ApiError, MessageService } from '../../../../../core';
import { ClienteGrupoEconomico } from '../cliente-grupo-economico';
import { ClienteGrupoEconomicoSearchCliente } from '../../../../cliente-grupo-economico';
import { ClienteGrupoEconcomicoHttpService } from '../cliente-grupo-economico-http.service';

@Component({
    selector: 'sgt-cliente-grupo-economico-select',
    templateUrl: './cliente-grupo-economico-select.component.html',
    styleUrls: ['./cliente-grupo-economico-select.component.less']
})
export class ClienteGrupoEconomicoSelectComponent {
    grupoEconomico: ClienteGrupoEconomico;
    @Input() subTitle: string = null;
    @Output() changeSelecteds = new EventEmitter<ClienteGrupoEconomicoSearchCliente[]>();

    constructor(private messageService: MessageService,
                private clienteGrupoEconcomicoHttpService: ClienteGrupoEconcomicoHttpService) { }

    /**
     * Carrega o grupo econômico do cliente e os demais clientes deste grupo econômico
     *
     * @param idCliente ID do cliente pertencente ao grupo econômico
     * @param selectAll se deve selecionar por padrão todos os clientes do grupo econômico.
     */
    search(idCliente: number, selectAll = true) {
        this.clienteGrupoEconcomicoHttpService.load(idCliente)
            .subscribe(
                grupoEconomico => {
                    this.grupoEconomico = grupoEconomico;

                    if (selectAll) {
                        this.grupoEconomico?.clientes?.forEach(cliente => cliente.selected = true);
                        this.select();
                    }
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao carregar o grupo econômico do cliente', error)
            );
    }

    /** Obtem os clientes do grupo econômico selecionados */
    private getSelecteds(): ClienteGrupoEconomicoSearchCliente[] {
        const selecteds: ClienteGrupoEconomicoSearchCliente[] = [];
        this.grupoEconomico?.clientes.forEach(cliente => {
            if (cliente.selected) {
                selecteds.push(cliente);
            }
        });

        return selecteds;
    }

    /** Ao selecionar um cliente */
    select() {
        // Emitindo evendo que um cliente foi selecionado e enviando todos os clientes selecionados
        this.changeSelecteds.emit(this.getSelecteds());
    }
}
